import React from 'react';

import { useSchedulerPeriodNumberOfWeeks } from '@sbv-clients/data-access-api';
import { Tab, Tabs } from '@sbv-clients/ui-shared';

export function WeekTabs({
  useContextFn,
}: {
  useContextFn: () => {
    facilityId?: number;
    departmentId: number;
    week: number;
    setWeek: (value: number) => void;
  };
}) {
  const { week, setWeek, facilityId, departmentId } = useContextFn();
  const { schedulerPeriodNumberOfWeeks } = useSchedulerPeriodNumberOfWeeks({
    facilityId,
    departmentId,
  });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setWeek(newValue);
  };

  const height = 52;
  return (
    <Tabs
      sx={{ height: height, minHeight: height }}
      value={week}
      onChange={handleChange}
    >
      {Array.from({ length: schedulerPeriodNumberOfWeeks }, (_, i) => (
        <Tab
          key={i}
          disableRipple
          sx={{ height: height, minHeight: height }}
          label={`Week ${i + 1}`}
          value={i + 1}
        />
      ))}
    </Tabs>
  );
}
